// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"151":"697a76b4","203":"af80b3d1","299":"41e2213d","373":"f42893d1","578":"a187c788","635":"7f1e2b51","736":"ff635672","771":"f3be1586","982":"883c54b5"}[chunkId] + ".chunk.js";
};